import { twMerge } from 'tailwind-merge';
import kakao from '@/assets/images/kakao_map.png';
import naver from '@/assets/images/naver_map.png';
import tmap from '@/assets/images/t_map.png';

type MapButtonProps = {
	type: 'naver' | 'kakao' | 'tmap';
	onClick?: () => void;
	className?: string;
	disabled?: boolean;
};

const MapButton = ({ type, onClick, className, disabled }: MapButtonProps) => {
	const image = {
		naver,
		kakao,
		tmap,
	}[type];

	const label = {
		naver: '네이버 길찾기',
		kakao: '카카오 맵',
		tmap: '티맵',
	}[type];

	return (
		<button
			type="button"
			onClick={onClick}
			disabled={disabled}
			className={twMerge(
				'flex h-21 cursor-pointer flex-col items-center justify-center gap-2 rounded-xl bg-mantang-gray-100 disabled:cursor-not-allowed disabled:opacity-40',
				className,
			)}
		>
			<img src={image} alt={label} className="h-7 w-7" />
			<span className="font-semibold text-mantang-gray-700 text-xs">
				{label}
			</span>
		</button>
	);
};

export default MapButton;
